<script lang="ts" setup>
const isShowSplitModal = defineModel('isShowSplitModal', { default: false });
const props = defineProps<{ amount: number; withShadow?: boolean }>();

const { yandexPayMerchantId } = useRuntimeConfig().public;
const { yandexSplitThreshold } = storeToRefs(useSiteStore());
const { createYandexPaySession } = useYandexPay();
const currentYandexPaySession = ref();

async function mountWidget() {
  currentYandexPaySession.value = await createYandexPaySession(props.amount);

  const yaPayWidgetSelector = document.querySelector('#yandex-split-widget');

  currentYandexPaySession.value.mountWidget(yaPayWidgetSelector, {
    widgetType: window.YaPay.WidgetType.BnplPreview,
    widgetTheme: window.YaPay.WidgetTheme.Light,
    borderRadius: 8,
  });
}

const isShowSpinner = ref(true);

watch(
  () => isShowSplitModal.value,
  () => {
    if (isShowSplitModal.value) {
      setTimeout(() => {
        isShowSpinner.value = false;
      }, 700);
    } else {
      isShowSpinner.value = true;
    }
  },
);
</script>

<template>
  <div v-show="amount && yandexSplitThreshold && amount > yandexSplitThreshold">
    <button
      class="w-full"
      @click="isShowSplitModal = true"
    >
      <div
        :class="{ 'shadow-md': withShadow }"
        class="yandex-pay-badge"
      >
        <yandex-pay-badge
          :amount
          :merchant-id="yandexPayMerchantId"
          align="center"
          color="primary"
          size="M"
          type="bnpl"
          variant="detailed"
        />
      </div>
    </button>

    <BaseModal
      v-model="isShowSplitModal"
      @close="isShowSplitModal = false"
      @opened="mountWidget"
    >
      <div
        id="yandex-split-widget"
        class="relative min-h-72"
      >
        <Transition name="loader">
          <div
            v-if="isShowSpinner"
            class="absolute z-10 flex items-center justify-center h-full w-full bg-white opacity-70"
          >
            <SvgoSpinner
              :font-controlled="false"
              class="size-14 animate-spin"
              filled
              title="Идет загрузка..."
            />
          </div>
        </Transition>
      </div>

      <slot />
    </BaseModal>
  </div>
</template>

<style lang="scss">
.yandex-pay-badge {
  display: flex;
  justify-content: center;
  padding: 16px;
  border: 1px solid $hell-black-10;
  border-radius: 12px;
  background-color: $white;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.7;
  }
}

@include screen-sm {
  .base-modal__content {
    min-width: 600px;
  }
}
</style>
